/* eslint-disable */
import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import Axios from 'axios';
import * as yup from "yup";
import {
  Form as FormUi,
  Container,
  Checkbox,
  TextArea, Button, Icon
} from "semantic-ui-react";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import AddUserTable from "./addUserTable";
import cogoToast from "cogo-toast";

//Dropdowns
import AddCity from "../dynamicComponent/addCity";
import BillingPartyDropdown from "../dynamicComponent/billingPartyDropdown";
import BillingPartyBranchDropdown from '../dynamicComponent/billingPartyBranchDropdown';
import {
  FIELD_IS_REQUIRED, INVALID_ADDRESS,
  INVALID_EMAIL, INVALID_FIELDS, INVALID_GST_NUMBER,
  INVALID_LAND_LINE, INVALID_LATITUDE,
  INVALID_LONGITUDE, INVALID_MOBILE_NO,
  INVALID_NAME, INVALID_PAN_NUMBER,
  INVALID_PINCODE
} from "../../utils/validationConstant";
import { customerNo, COOKIE_USER_ID, COOKIE_USER_TOKEN, FEATURES } from "../../utils/constant";
import MandatoryMark from "../common/mandatorymark";

const InsertConsignor = ({ values, t, editData, setFieldValue, touched, errors, usersList, action }) => {

  const [lat, setlat] = useState(0);
  const [long, setlong] = useState(0);

  let fetchCityInfo = (data) => {
    setlat(data.lattitude)
    setlong(data.longitude)
  }


  const getBillingPartySelected = (billingPartyId) => {
    if (billingPartyId) {
      let token = COOKIE_USER_TOKEN
      let userId = COOKIE_USER_ID

      Axios.get(`${process.env.REACT_APP_MASTER_API}/billing_party_branch?customerNumber=${customerNo}&userId=${userId}&billingPartyId=${billingPartyId}`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token
        }
      }).then((response => {
        setFieldValue("billingPartyBranchArray", response.data.resultSet)

      }))
        .catch(error => console.log(error))
    } else {
      setFieldValue("billingPartyBranchArray", [])
    }
  }

  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="m-3 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("consignor_code.title") || "Consignor Code"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">

                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="consignorCode"
                    placeholder={t("consignor_code.placeholder") || "Code"}
                    disabled={editData.consignorCode ? true : false}
                    error={touched.consignorCode && errors.consignorCode ? true : false}

                  />
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("consignor_name.title") || "Consignor Name"}{" "}<MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="consignorName"
                    placeholder={t("consignor_name.placeholder") || "Name"}
                    error={touched.consignorName && errors.consignorName ? true : false}
                  />
                  {touched.consignorName && errors.consignorName ? (
                    <div className="error-msg">
                      {errors.consignorName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("email_id.title") || "Email Id"}{" "}<MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="email"
                    placeholder={t("email_id.placeholder") || "Email Id"}
                    error={touched.email && errors.email ? true : false}
                  />
                  {touched.email && errors.email ? (
                    <div className="error-msg">
                      {errors.email}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2} />
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("mobile_number.title") || "Mobile No."}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="phone"
                    placeholder={t("mobile_number.placeholder") || "Mobile No."}
                    error={touched.phone && errors.phone ? true : false}
                  />
                  {touched.phone && errors.phone ? (
                    <div className="error-msg">
                      {errors.phone}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("landline_number.title") || "Landline No."}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="landLineNo"
                    placeholder={t("landline_number.placeholder") || "Landline No."}
                    error={touched.landLineNo && errors.landLineNo ? true : false}
                  />
                  {touched.landLineNo && errors.landLineNo ? (
                    <div className="error-msg">
                      {errors.landLineNo}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("contact_person.title") || "Contact Person Name"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="contactPersonName"
                    placeholder={t("contact_person.placeholder") || "Contact Person"}
                    error={touched.contactPersonName && errors.contactPersonName ? true : false}

                  />
                  {touched.contactPersonName && errors.contactPersonName ? (
                    <div className="error-msg">
                      {errors.contactPersonName}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline >
                <FormUi.Field width={2} >
                  <label className="labelName">
                    {t("company_address.title") || "Company Address"}{" "}<MandatoryMark/>
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    as={TextArea}
                    className="ui input"
                    name="address"
                    placeholder={
                      t("company_address.placeholder") || "Company Address"
                    }
                    error={touched.address && errors.address ? true : false}
                  />
                  {touched.address && errors.address ? (
                    <div className="error-msg">
                      {errors.address}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">{t("city.title") || "City"}</label>
                </FormUi.Field>
                <FormUi.Field width={4}>
                  <Fieldmik
                    type="text"
                    component={AddCity}
                    getCityInfo={fetchCityInfo}
                    name="cityId"
                    placeholder={editData.cityName}
                  />
                </FormUi.Field>
              </FormUi.Group>
              {
                localStorage.getItem("customerNumber") == 1183 ?
                  <FormUi.Group>
                    <FormUi.Field width={2}>
                      <label className="labelName">{"Billing Party"}</label>
                    </FormUi.Field>
                    <FormUi.Field width={4}>
                      <Fieldmik
                        type="text"
                        component={BillingPartyDropdown}
                        name="billingPartyId"
                        getBillingPartySelected={getBillingPartySelected}
                        value={values.billingPartyId}
                      />
                      {touched.billingPartyId && errors.billingPartyId ? (
                        <div>
                          {errors.billingPartyId}
                        </div>
                      ) : null}
                    </FormUi.Field>
                    <FormUi.Field width={2}></FormUi.Field>
                    {values.billingPartyId ? (
                      <>
                        <FormUi.Field width={2}>
                          <label className="labelName">{"Billing Party Branch"}</label>
                        </FormUi.Field>
                        <FormUi.Field width={4}>
                          <Fieldmik
                            type="text"
                            component={BillingPartyBranchDropdown}
                            name="billingPartyBranchId"
                            billingPartyBranchArray={values.billingPartyBranchArray}
                            value={values.billingPartyBranchId}
                            billingPartyid={values.billingPartyid}
                          />
                          {touched.billingPartyBranchId && errors.billingPartyBranchId ? (
                            <div>
                              {errors.billingPartyBranchId}
                            </div>
                          ) : null}
                        </FormUi.Field>
                      </>
                    ) : ""}
                  </FormUi.Group>
                  :
                  ""
              }

              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("latitude.title") || "Latitude"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="checkPointLattitude"
                    placeholder={t("latitude.placeholder") || "Latitude"}
                    error={touched.checkPointLattitude && errors.checkPointLattitude ? true : false}
                  />
                  {touched.checkPointLattitude && errors.checkPointLattitude ? (
                    <div className="error-msg">
                      {errors.checkPointLattitude}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2} />
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("longitude.title") || "Longitude"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="checkPointLongitude"
                    placeholder={t("longitude.placeholder") || "Longitude"}
                    error={touched.checkPointLongitude && errors.checkPointLongitude ? true : false}
                  />
                  {touched.checkPointLongitude && errors.checkPointLongitude ? (
                    <div className="error-msg">
                      {errors.checkPointLongitude}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("gst_no.title") || "GST No."}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="gstNumber"
                    placeholder={t("gst_no.placeholder") || "GST No."}
                    error={touched.gstNumber && errors.gstNumber ? true : false}
                  />
                  {touched.gstNumber && errors.gstNumber ? (
                    <div className="error-msg">
                      {errors.gstNumber}
                    </div>
                  ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("pincode.title") || "Pincode"}{" "}{FEATURES.pincodeOptionalForConsignorMaster ? "" : <MandatoryMark/>}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="pincode"
                    placeholder={t("pincode.placeholder") || "Pincode"}
                    error={touched.pincode && errors.pincode ? true : false}
                  />
                  {touched.pincode && errors.pincode ? (
                    <div className="error-msg">
                      {errors.pincode}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>


              <FormUi.Group inline>
                <FormUi.Field width={2}>
                  <label className="labelName">
                    {t("radius.title") || "Radius"}
                  </label>
                </FormUi.Field>
                <FormUi.Field width={4} className="display-grid-center-imp">
                  <Fieldmik
                    type="text"
                    className="ui input"
                    name="checkPointRadius"
                    placeholder={t("radius.placeholder") || "Radius"}
                    error={touched.checkPointRadius && errors.checkPointRadius ? true : false}
                  />
                  {touched.checkPointRadius && errors.checkPointRadius ? (
                    <div className="error-msg">
                      {errors.checkPointRadius}
                    </div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {t("action_button.submit") || "Submit"}
          </button>
        </Container>
        {action && action == "title" ? (
          null
        ) : (
          <AddUserTable mainId={editData.consignorId} modalType="consignor" usersItems={usersList} />
        )}
      </Formiker>
    </React.Fragment>
  );
};

const FormikConsignor = withFormik({
  validationSchema: yup.object({
    consignorCode: yup.string().optional(),
    consignorName: yup.string().required(FIELD_IS_REQUIRED),
    email: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Email, INVALID_EMAIL),
    phone: yup.string().matches(AllRegex.MobileNumber, INVALID_MOBILE_NO),
    landLineNo: yup.string().matches(AllRegex.LandlineNumber, INVALID_LAND_LINE),
    contactPersonName: yup.string().optional().matches(AllRegex.Name, INVALID_NAME),
    address: yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Address, INVALID_ADDRESS),
    pincode: FEATURES.pincodeOptionalForConsignorMaster ?  yup.string().optional().nullable().matches(AllRegex.Pincode, INVALID_PINCODE) : yup.string().required(FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_PINCODE),
    checkPointLattitude: yup.string().optional().matches(AllRegex.Latitude, INVALID_LATITUDE),
    checkPointLongitude: yup.string().optional().matches(AllRegex.Longitude, INVALID_LONGITUDE),
    gstNumber: yup.string().optional().matches(AllRegex.GSTIN, INVALID_GST_NUMBER),
    panNumber: yup.string().optional().matches(AllRegex.PANIN, INVALID_PAN_NUMBER),
    billingPartyId: customerNo == 1122 ? yup.string().required(FIELD_IS_REQUIRED) : yup.string().optional(),
    billingPartyBranchId: customerNo == 1122 ? yup.string().required(FIELD_IS_REQUIRED) : yup.string().optional(),
    checkPointRadius : yup.string().optional().matches(AllRegex.INT_OR_DECIMAL_WITH_MAX_5_DIGITS, INVALID_FIELDS.INVALID_FIELD("Checkpoint Radius")),
  }),
  enableReinitialize: true,

  mapPropsToValues: (props) => ({
    checkPointMasterId: props?.editData?.checkPointMasterId || "",
    consignorId: props?.editData?.consignorId || "",
    consignorName: props?.editData?.consignorName || "",
    consignorCode: props?.editData?.consignorCode || "",
    email: props?.editData?.email || "",
    phone: props?.editData?.phone || "",
    landLineNo: props?.editData?.landLineNo || "",
    contactPersonName: props?.editData?.contactPersonName || "",
    address: props?.editData?.address || "",
    pincode: props?.editData?.pincode || "",
    checkPointLattitude: props?.editData?.checkPointLattitude || "",
    checkPointLongitude: props?.editData?.checkPointLongitude || "",
    checkPointRadius: props?.editData?.checkPointRadius || "",
    cityId: props?.editData?.cityId || "",
    billingPartyId: props?.billingPartyId || "",
    billingPartyBranchId: props?.billingPartyBranchId || "",
    consignorBillingPartyBranchMapId: props?.consignorBillingPartyBranchMapId || "",
    state: props?.editData?.state || "",
    gstNumber: props?.editData?.gstNumber || "",
    panNumber: props?.editData?.panNumber || "",
    billingPartyBranchArray: props?.billingPartyBranchArray || []
  }),


  async handleSubmit(values, { props }) {
    if (props.editData.consignorId) {
      if (values.consignorBillingPartyBranchMapId) {
        const deleteData = {
          "consignorBillingPartyBranchMapId": values.consignorBillingPartyBranchMapId,
          "customerNumber": customerNo,
          "userId": COOKIE_USER_ID
        }

        Axios.delete(`${process.env.REACT_APP_MASTER_API}/mappings/consignor_billing_party_branch/${values.consignorBillingPartyBranchMapId}`, {
          data: deleteData,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': COOKIE_USER_TOKEN
          }
        }).then((response => {
        }))
          .catch(error => console.log(error))
      }

      await UpdateAxios({
        url: "consignorMaster",
        payload: { ...values },
        uniqueId: props.editData.consignorId,
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };

          const headerData = {
            "consignorId": props.editData.consignorId,
            "billingPartyId": values.billingPartyId,
            "billingPartyBranchId": values.billingPartyBranchId,
            "customerNumber": customerNo,
            "userId": COOKIE_USER_ID
          }

          if (values.billingPartyId) {
            Axios.put(`${process.env.REACT_APP_MASTER_API}/mappings/consignor_billing_party_branch/`, headerData, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': COOKIE_USER_TOKEN
              }
            }).then((response => {
              if (response.data.status !== 200) {
                let error_alert = {
                  type: "error",
                  messageHeader: "Error",
                  messageBody: response.data.message,
                };
                props.errorAlertDispatcher(error_alert);
                return;
              }
            }))
              .catch(error => console.log(error))
          }
            props.successAlertDispatcher(alert);
            props.onFormSubmit();
          

        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          console.log(err);
          props.errorAlertDispatcher(alert);
        });
    } else {
      await CreatAxios({
        url: "consignorMaster",
        payload: { ...values },
      })
        .then((res) => {
          let alert = {
            type: "success",
            messageHeader: "Success",
            messageBody: res.data.message,
          };

          const consignorId = res.data.lastConsignorId;
          if (consignorId) {
            const headerData = {
              "consignorId": consignorId,
              "billingPartyId": values.billingPartyId,
              "billingPartyBranchId": values.billingPartyBranchId,
              "customerNumber": customerNo,
              "userId": COOKIE_USER_ID
            }

            Axios.put(`${process.env.REACT_APP_MASTER_API}/mappings/consignor_billing_party_branch/`, headerData, {
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': COOKIE_USER_TOKEN
              }
            }).then((response => {
              console.log("Mapping Data", response)
            }))
              .catch(error => console.log(error))
          }
          props.successAlertDispatcher(alert);
          props.onFormSubmit();
        })
        .catch((err) => {
          let alert = {
            type: "error",
            messageHeader: "Error",
            messageBody: err.data.message,
          };
          props.errorAlertDispatcher(alert);
        });
    }
  },
})(InsertConsignor);

export default connect(null, {
  successAlertDispatcher,
  warningAlertDispatcher,
  errorAlertDispatcher,
  infoAlertDispatcher,
})(translate("create_consignor")(FormikConsignor));
